import {
    createAction,
    createSlice
} from '@reduxjs/toolkit';
import { CoreMsgTypes, UserSecondaryApiTypeRecord } from '@tassat/fred-definitions';

export type UserApiTypeState = {
    [userId: string]: {
        [usersApiTypeId: string]: UserSecondaryApiTypeRecord;
    };
};

const initialState: UserApiTypeState = {};

const initialLoadAction = createAction<{ userSecondaryApiTypeRecords: {
    [userApiTypeId: string]: any;
}; }>('InitialLoad');
const userApiTypeRecordAction = createAction<UserSecondaryApiTypeRecord>(CoreMsgTypes.UserSecondaryApiTypeRecord);

const userApiTypeSlice = createSlice({
    name: 'userApiTypes',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(
                initialLoadAction,
                (
                    state,
                    action
                ) => {
                    if (action.payload.userSecondaryApiTypeRecords) {
                        Object.values(action.payload.userSecondaryApiTypeRecords)
                            .forEach((userApiTypeRecord: UserSecondaryApiTypeRecord) => {
                                state[userApiTypeRecord.UserId] = { [userApiTypeRecord.UserSecondaryApiTypeId]: userApiTypeRecord };
                            });
                    }
                }
            )
            .addCase(userApiTypeRecordAction, (state, action) => {
                state[action.payload.UserId] = { [action.payload.UserSecondaryApiTypeId]: action.payload };
            });
    }
});

export default userApiTypeSlice.reducer;